import React, { useState, useEffect } from "react";

const API_URL =
  process.env.REACT_APP_BACKEND_URL ||
  "https://topnationapp-1-api.onrender.com";

export default function BusinessProfile() {
  const [profile, setProfile] = useState({
    company_name: "",
    category: "",
    website: "",
    description: "",
    linkedin: "",
    instagram: "",
    tiktok: "",
    facebook: "",
    twitter: "",
  });

  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const res = await fetch(`${API_URL}/api/profile`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        const data = await res.json();

        setProfile({
          company_name: data.company_name || "",
          category: data.category || "",
          website: data.website || "",
          description: data.description || "",
          linkedin: data.linkedin || "",
          instagram: data.instagram || "",
          tiktok: data.tiktok || "",
          facebook: data.facebook || "",
          twitter: data.twitter || "",
        });
      }
    } catch (err) {
      console.error("Failed loading profile", err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setProfile({
      ...profile,
      [e.target.name]: e.target.value,
    });
  };

  const saveProfile = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    setSaving(true);

    try {
      const res = await fetch(`${API_URL}/api/profile`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(profile),
      });

      if (res.ok) {
        alert("✅ Profile saved");
      } else {
        alert("❌ Failed saving profile");
      }
    } catch (err) {
      alert("❌ Error saving profile");
    } finally {
      setSaving(false);
    }
  };

    const deleteAccount = async () => {
    const confirmed = window.confirm(
      "Are you sure you want to permanently delete your account?"
    );

    if (!confirmed) return;

    const token = localStorage.getItem("token");

    try {
      const res = await fetch(`${API_URL}/api/account/delete`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        localStorage.removeItem("token");
        alert("Account deleted successfully");
        window.location.href = "/";
      } else {
        alert("Failed to delete account");
      }
    } catch (err) {
      alert("Error deleting account");
    }
  };
  if (loading) {
    return (
      <div className="bg-[#0a0a0a] border border-[#333] rounded-xl p-6 text-center text-gray-400">
        Loading profile...
      </div>
    );
  }

  return (
    <div className="bg-[#0a0a0a] border border-[#333] rounded-xl p-6">
      <h2 className="text-[#FFD700] text-xl font-bold mb-6">
        Business Profile
      </h2>

      <div className="grid md:grid-cols-2 gap-4">
        <input
          name="company_name"
          value={profile.company_name}
          onChange={handleChange}
          placeholder="Company / Brand Name"
          className="w-full bg-[#1a1a1a] border border-[#333] rounded-lg px-4 py-2 text-white"
        />

        <select
          name="category"
          value={profile.category}
          onChange={handleChange}
          className="w-full bg-[#1a1a1a] border border-[#333] rounded-lg px-4 py-2 text-white"
        >
          <option value="">Category</option>

          <option value="Accountant">Accountant</option>
          <option value="Advertising Agency">Advertising Agency</option>
          <option value="Agency">Agency</option>
          <option value="Apartment Building">Apartment Building</option>
          <option value="Architect">Architect</option>
          <option value="Art Gallery">Art Gallery</option>
          <option value="Attorney">Attorney</option>
          <option value="Auto Parts Store">Auto Parts Store</option>
          <option value="Auto Repair Shop">Auto Repair Shop</option>
          <option value="Automotive">Automotive</option>

          <option value="Bakery">Bakery</option>
          <option value="Bank">Bank</option>
          <option value="Bar">Bar</option>
          <option value="Barber Shop">Barber Shop</option>
          <option value="Beauty Salon">Beauty Salon</option>
          <option value="Bicycle Shop">Bicycle Shop</option>
          <option value="Bookstore">Bookstore</option>
          <option value="Business">Business</option>

          <option value="Car Dealer">Car Dealer</option>
          <option value="Car Wash">Car Wash</option>
          <option value="Carpenter">Carpenter</option>
          <option value="Catering Service">Catering Service</option>
          <option value="Coffee Shop">Coffee Shop</option>
          <option value="Consultant">Consultant</option>
          <option value="Construction Company">Construction Company</option>
          <option value="Content Creator">Content Creator</option>
          <option value="Courier Service">Courier Service</option>
          <option value="Crypto">Crypto</option>

          <option value="Day Care Center">Day Care Center</option>
          <option value="Delivery Service">Delivery Service</option>
          <option value="Dental Clinic">Dental Clinic</option>
          <option value="Dentist">Dentist</option>
          <option value="Department Store">Department Store</option>
          <option value="Design Agency">Design Agency</option>
          <option value="Doctor">Doctor</option>
          <option value="Dog Walker">Dog Walker</option>

          <option value="E-commerce">E-commerce</option>
          <option value="Education">Education</option>
          <option value="Electrician">Electrician</option>
          <option value="Electronics Store">Electronics Store</option>
          <option value="Entertainment">Entertainment</option>
          <option value="Event Planner">Event Planner</option>
          <option value="Exterminator">Exterminator</option>

          <option value="Fashion">Fashion</option>
          <option value="Fast Food Restaurant">Fast Food Restaurant</option>
          <option value="Finance">Finance</option>
          <option value="Financial Planner">Financial Planner</option>
          <option value="Fitness">Fitness</option>
          <option value="Fitness Center">Fitness Center</option>
          <option value="Florist">Florist</option>
          <option value="Food & Beverage">Food & Beverage</option>
          <option value="Furniture Store">Furniture Store</option>

          <option value="Garden Center">Garden Center</option>
          <option value="Gas Station">Gas Station</option>
          <option value="General Contractor">General Contractor</option>
          <option value="Grocery Store">Grocery Store</option>
          <option value="Gym">Gym</option>
          <option value="Gymnastics Center">Gymnastics Center</option>

          <option value="Hair Salon">Hair Salon</option>
          <option value="Hardware Store">Hardware Store</option>
          <option value="Health">Health</option>
          <option value="Health & Fitness">Health & Fitness</option>
          <option value="Hotel">Hotel</option>

          <option value="Ice Cream Shop">Ice Cream Shop</option>
          <option value="Influencer">Influencer</option>
          <option value="Information Services">Information Services</option>
          <option value="Insurance Agency">Insurance Agency</option>
          <option value="Interior Designer">Interior Designer</option>
          <option value="IT Support Services">IT Support Services</option>

          <option value="Italian Restaurant">Italian Restaurant</option>
          <option value="Jewelry Store">Jewelry Store</option>

          <option value="Karate School">Karate School</option>
          <option value="Kitchen Remodeler">Kitchen Remodeler</option>

          <option value="Landscaper">Landscaper</option>
          <option value="Laundry Service">Laundry Service</option>
          <option value="Law Firm">Law Firm</option>
          <option value="Legal Services">Legal Services</option>
          <option value="Library">Library</option>
          <option value="Locksmith">Locksmith</option>
          <option value="Luxury">Luxury</option>

          <option value="Manufacturer">Manufacturer</option>
          <option value="Marketing">Marketing</option>
          <option value="Marketing Agency">Marketing Agency</option>
          <option value="Massage Therapist">Massage Therapist</option>
          <option value="Media">Media</option>
          <option value="Medical Clinic">Medical Clinic</option>
          <option value="Mortgage Lender">Mortgage Lender</option>
          <option value="Moving Company">Moving Company</option>
          <option value="Museum">Museum</option>
          <option value="Music School">Music School</option>

          <option value="Nail Salon">Nail Salon</option>
          <option value="Non-profit Organization">Non-profit Organization</option>
          <option value="Notary Public">Notary Public</option>
          <option value="Nursery School">Nursery School</option>

          <option value="Office Furniture Store">Office Furniture Store</option>
          <option value="Office Space Rental Agency">Office Space Rental Agency</option>
          <option value="Optician">Optician</option>
          <option value="Optometrist">Optometrist</option>

          <option value="Painter">Painter</option>
          <option value="Personal Brand">Personal Brand</option>
          <option value="Pest Control Service">Pest Control Service</option>
          <option value="Pet Store">Pet Store</option>
          <option value="Pharmacy">Pharmacy</option>
          <option value="Photographer">Photographer</option>
          <option value="Physiotherapist">Physiotherapist</option>
          <option value="Pizza Restaurant">Pizza Restaurant</option>
          <option value="Plumber">Plumber</option>
          <option value="Print Shop">Print Shop</option>
          <option value="Property Management Company">Property Management Company</option>
          <option value="Pub">Pub</option>

          <option value="Real Estate Agency">Real Estate Agency</option>
          <option value="Restaurant">Restaurant</option>

          <option value="School">School</option>
          <option value="Security Guard Service">Security Guard Service</option>
          <option value="Shipping and Mailing Service">Shipping and Mailing Service</option>
          <option value="Shoe Store">Shoe Store</option>
          <option value="Software Company">Software Company</option>
          <option value="Spa">Spa</option>
          <option value="Sporting Goods Store">Sporting Goods Store</option>
          <option value="Sports">Sports</option>
          <option value="Startup">Startup</option>
          <option value="Storage Facility">Storage Facility</option>

          <option value="Tattoo Shop">Tattoo Shop</option>
          <option value="Taxi Service">Taxi Service</option>
          <option value="Technology">Technology</option>
          <option value="Travel Agency">Travel Agency</option>
          <option value="Tutoring Service">Tutoring Service</option>

          <option value="Urgent Care Center">Urgent Care Center</option>
          <option value="Used Car Dealer">Used Car Dealer</option>

          <option value="Veterinarian">Veterinarian</option>
          <option value="Video Production Service">Video Production Service</option>

          <option value="Website Designer">Website Designer</option>
          <option value="Wholesaler">Wholesaler</option>
          <option value="Wine Bar">Wine Bar</option>

          <option value="Yoga Studio">Yoga Studio</option>
          <option value="Zoo">Zoo</option>

          <option value="Other">Other</option>
        </select>

        <input
          name="website"
          value={profile.website}
          onChange={handleChange}
          placeholder="Website"
          className="w-full bg-[#1a1a1a] border border-[#333] rounded-lg px-4 py-2 text-white"
        />

        <input
          name="linkedin"
          value={profile.linkedin}
          onChange={handleChange}
          placeholder="LinkedIn"
          className="w-full bg-[#1a1a1a] border border-[#333] rounded-lg px-4 py-2 text-white"
        />

        <input
          name="instagram"
          value={profile.instagram}
          onChange={handleChange}
          placeholder="Instagram"
          className="w-full bg-[#1a1a1a] border border-[#333] rounded-lg px-4 py-2 text-white"
        />

        <input
          name="tiktok"
          value={profile.tiktok}
          onChange={handleChange}
          placeholder="TikTok"
          className="w-full bg-[#1a1a1a] border border-[#333] rounded-lg px-4 py-2 text-white"
        />

        <input
          name="facebook"
          value={profile.facebook}
          onChange={handleChange}
          placeholder="Facebook"
          className="w-full bg-[#1a1a1a] border border-[#333] rounded-lg px-4 py-2 text-white"
        />

        <input
          name="twitter"
          value={profile.twitter}
          onChange={handleChange}
          placeholder="Twitter / X"
          className="w-full bg-[#1a1a1a] border border-[#333] rounded-lg px-4 py-2 text-white"
        />

        <textarea
          name="description"
          value={profile.description}
          onChange={handleChange}
          placeholder="Business Description"
          className="md:col-span-2 w-full bg-[#1a1a1a] border border-[#333] rounded-lg px-4 py-2 text-white"
        />

      </div>
      <div className="mt-6 flex gap-3 flex-wrap">

        <button
          onClick={saveProfile}
          disabled={saving}
          className="bg-[#FFD700] text-black font-bold px-6 py-2 rounded-lg"
        >
          {saving ? "Saving..." : "Save Profile"}
        </button>

        <button
onClick={deleteAccount}
          className="bg-red-800 text-white font-bold px-6 py-2 rounded-lg border border-red-500"
        >
          Delete Account
        </button>
</div>

</div>

);
}
